import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { RequestService, LayoutUtilsService, LoaderService } from '../../../shared/services';
import { FormControl, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-custom-select-autocomplete',
  templateUrl: './custom-select-autocomplete.component.html',
  styleUrls: ['./custom-select-autocomplete.component.scss']
,
  standalone: false})
export class CustomSelectAutocompleteComponent implements OnInit {
  public apiCallSubscription: any = undefined;
  public errorMessage: string = '';
  public loading: boolean = false;
  public dataText: string = '';
  stateCtrl = new FormControl();
  includedData: Array<any> = [];
  selectData: Array<any> = [];
  selectedData: any = undefined;
  filteredData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  /* pagination Info */
  pageSize = 25;
  pageNumber = 1;
  orderDir = 'asc';
  orderBy = 'name';
  searchText = '';

  @Input() filters: any;
  @Input() addAll: boolean = false;
  @Input() clearable: boolean = false;
  @Input() canDelete: boolean = false;
  @Input() include: any[] = [];
  @Input() displayName: string[] = ['name', 'text'];
  @Input() dataTypeFields: string[] = ['name'];
  @Input() placeholder: string = '';
  @Input() dataType: string;
  @Input() replaceField: string = '';
  @Input() dataTypeDisplay: string;
  @Input() fields: string[] = ['name'];
  public _value: any = undefined;
  @Input()
  set value(value: any) {
    this._value = value;
    this.selectedData = value;
    this.loadData();
  }
  get value(): any {
    return this._value;
  }
  @Output() onSelectReturn = new EventEmitter<any>();
  constructor(
    private requestService: RequestService,
    private layoutUtilsService: LayoutUtilsService
  ) {
  }

  ngOnInit() {
    // this.loadData();
  }
  private getSelectedItem(val) {
    for (let itm of this.selectData) {
      if (val === itm._id) {
        return itm
      }
    }
    return '';
  }
  displayFn(data?: any): string | undefined {
    return data ? data.text : undefined;
  }
  public clearData() {
    this.dataText = '';
  }
  public loadData() {
    this.loadDataSearch(true);
  }
  public loadDataSearch(setValue: boolean = false) {
    if (this.loading && this.apiCallSubscription) {
      this.apiCallSubscription.unsubscribe();
      this.loading = false;
    }
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      let include = undefined;
      if (this.selectedData && this.selectedData._id !== 'all') {
        include = [this.selectedData._id];
      }
      let filterConfiguration = this.filters;
      this.apiCallSubscription = this.requestService.postRequest({ page: this.pageNumber, term: this.searchText, fields: this.replaceField ? [this.replaceField] : this.fields, orderDir: this.orderDir, orderBy: this.orderBy, perpage: this.pageSize, filter: filterConfiguration, termfields: this.dataTypeFields, include: include }, this.dataType + '/search' + (this.replaceField || this.fields.length ? '' : '/summary'), (data, error) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification('Error:' + error, 'Dismiss');
        }
        if (data) {
          let res = [];
          if (this.replaceField) {
            data.results.map(i => {
              res.push({ _id: i._id, text: i[this.replaceField] });
            });
          }
          else {
            if (this.fields.length) {
              data.results.map(i => {
                res.push({ _id: i._id, text: i.name, ...i });
              });
            }
            else {
              res = data.results;
            }
          }

          this.selectData = JSON.parse(JSON.stringify(res));
          this.includedData = JSON.parse(JSON.stringify(res));
          if (this.selectedData && this.selectedData._id && this.selectedData._id !== 'all') {
            let selectedDataAvailable = this.getSelectedItem(this.selectedData._id) !== '';
            if (!selectedDataAvailable) {
              this.includedData.unshift(this.selectedData);
            }
          }
          if (this.addAll) {
            this.includedData.unshift({ _id: 'all', text: 'All' });
          }

        } else {
          this.selectData = [];
          this.includedData = [{ _id: 'all', text: 'All' }];
        }
        if (setValue) {
          if (this.selectedData) {
            this.setValueControl(this.selectedData);
          } else {
            if (this.addAll) {
              this.setValueControl({ _id: 'all', text: 'All' });
            }
          }
        }
        this.filteredData.next(this.selectData);
        this.loading = false;
      });
    }
  }
  getDataByID(id): any {
    for (let lst of this.includedData) {
      if (lst._id === id) {
        return lst.text;
      }
    }
    return '';
  }
  termSearch(term): any {
    this.searchText = term;
    // this.onSelectReturn.emit({_id: undefined, text: term});
    this.loadDataSearch();
  }
  onBlurMethod(term): any {
    if (this.selectedData && this.selectedData._id && this.selectedData._id !== '') {
      this.setValueControl(this.selectedData);
    }
    this.termSearch('');
  }
  setValueControl(val) {
    this.stateCtrl.setValue(val);
  }
  public setAttribute(val) {
    // this.selectedData = val;
    // this.termSearch('');
    this.searchText = '';
    this.onSelectReturn.emit(val);
  }
  public deleteItem(e, val) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (!this.loading) {
      const _title: string = this.dataTypeDisplay + ' Deletion';
      const _description: string = 'Are you sure to permanently delete this ' + this.dataTypeDisplay + '?';
      const _waitDesciption: string = 'Deleting...';

      const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
      dialogRef.afterClosed().subscribe(res => {
        if (!res) {
          return;
        }
        this.realDelete(val.uid);
      });
    }
  }
  public realDelete(id: any) {
    const _deleteMessage = this.dataTypeDisplay + ` Deleted Successfully.`;
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.deleteSingleData(this.dataType, id, (data, error) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification('Error:' + error, 'Dismiss');
        }
        this.loading = false;
        if (data) {
          this.layoutUtilsService.showNotification(_deleteMessage, 'Dismiss');
          this.loadData();
        }
      });
    }
  }
}
